import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ENVIRONMENT, Environment, ICustomerOptions, ILookUpType, IPaginationResponseModel, ISavedAddressModel, OptionService, RolePermissionService, SavedContactMapping, SavedContactsService, UtilitiesService, SavedAddressService, ContactUtilities, ISavedContactModel } from 'lib-core-shared';

enum State {
  NewContact, IncompleteContact, SelectDefault, Loading, Error
}
interface ITitle {
  id: number,
  name: string
}
@Component({
  selector: 'app-resolve-customer-contact',
  templateUrl: './resolve-customer-contact.component.html',
  styleUrls: ['./resolve-customer-contact.component.scss']
})
export class ResolveCustomerContactComponent implements OnInit {
  state: State = 0;
  form!: FormGroup;
  @Output() successEmitter = new EventEmitter<ISavedContactModel>();
  @Output() closeEmitter = new EventEmitter<string>();
  public submitButtonDisabled = false;
  isBusy!: boolean;
  @Input() customerId!: string;
  @Input() customerAddress!: ISavedAddressModel;
  @Input() defaultContact!: ISavedContactModel;
  fb: any;
  private validatorContacts: ISavedContactModel[] = [];
  mapping!: SavedContactMapping;
  savedContacts: ISavedContactModel[] = [];
  savedAddresses: ISavedAddressModel[] = [];
  public languages: ILookUpType[] = [];
  public titles!: ITitle[];
  public formSubmitted: boolean = false;
  telephoneNumberVerified: boolean = false;
  mobileNumberVerified: boolean = false;
  showTelephoneNumber: boolean = false; 
  showMobileNumber: boolean = false;

  constructor(
    @Inject(ENVIRONMENT) private env: Environment,
    private readonly savedAddressService: SavedAddressService,
    private readonly savedContactsService: SavedContactsService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public modalService: NgbModal,
    public utilitiesService: UtilitiesService,
    public roleService: RolePermissionService,
    public optionsService: OptionService,
    public contactUtils: ContactUtilities
  ) {
  }

  ngOnInit(): void {

    this.titles = this.env.titles;

    console.log(this.customerId)

    this.mapping = new SavedContactMapping();

    this.optionsService.getOptions().subscribe((r: ICustomerOptions) => {
      this.languages = r.languages;
    })

    this.savedAddressService.getCustomerAddresses(this.customerId).subscribe((x: ISavedAddressModel[]) => {
      this.savedAddresses = x.map(x => x);
    });

    //if there is no default contact for this customer we need to get any saved contacts and ask the user to select one as default
    if (this.defaultContact == undefined) {

      this.savedContactsService.getAll(this.customerId).subscribe((savedContacts: IPaginationResponseModel<ISavedContactModel>) => {

        if (savedContacts.data.length == 0) {
          this.createNewContactForm();
        } else {
          this.selectContactAsDefaultForm(savedContacts.data);
        }

      }, (error) => {
        this.fb = {
          text: `${error.status} : ${error.statusText ? error.statusText : 'An error occurred'}`,
          error: error
        };
      });

    } else if (this.contactUtils.isSavedContactComplete(this.defaultContact) == false) {
      this.fillAnIncompleteDefaultContactForm(this.defaultContact);
    }


  }

  public createNewContactForm(): void {
    this.state = State.NewContact;
    this.form = new FormGroup({
      title: new FormControl(null, Validators.required),
      firstName: new FormControl(null, Validators.required),
      lastName: new FormControl(null, Validators.required),
      emailAddress: new FormControl(null, Validators.required),
      telephoneNumber: new FormControl(this.customerAddress?.details?.contactNumber ? this.customerAddress?.details?.contactNumber : null),
      mobileNumber: new FormControl(this.customerAddress?.details?.contactNumber ? this.customerAddress?.details?.contactNumber : null),
      jobTitle: new FormControl(null),
      isDefault: new FormControl(true),
      address: new FormControl(this.customerAddress),
      //country: new FormControl(null, Validators.required),
      language: new FormControl(false),
      isMarketingRecipient: new FormControl(false),
      isOrderProgressRecipient: new FormControl(false),
      isShippingNotificationRecipient: new FormControl(false),
      isInvoiceRecipient: new FormControl(false),
      isCreditNoteRecipient: new FormControl(false),
      isRemarketTheBasketRecipient: new FormControl(false),
    })
  }

  public selectContactAsDefaultForm(contacts: ISavedContactModel[]): void {
    this.state = State.SelectDefault;
    this.savedContacts = contacts;
    this.form = new FormGroup({
      defaultContact: new FormControl(contacts[0], Validators.required),
    })

    if (contacts.length == 1) {
      this.saveNewDefaultContact(this.form);
    }

  }

  public fillAnIncompleteDefaultContactForm(defaultContact: ISavedContactModel): void {
    this.state = State.IncompleteContact;
    this.form = new FormGroup({
      id: new FormControl(defaultContact.id, Validators.required),
      title: new FormControl(defaultContact.title, Validators.required),
      firstName: new FormControl(defaultContact.firstName, Validators.required),
      lastName: new FormControl(defaultContact.lastName, Validators.required),
      emailAddress: new FormControl(defaultContact.emailAddress, Validators.required),
      telephoneNumber: new FormControl(defaultContact.telephoneNumber ? defaultContact.telephoneNumber : (this.customerAddress?.details?.contactNumber ? this.customerAddress?.details?.contactNumber : null)),
      mobileNumber: new FormControl(defaultContact.mobileNumber ? defaultContact.mobileNumber : (this.customerAddress?.details?.contactNumber ? this.customerAddress?.details?.contactNumber : null)),
      jobTitle: new FormControl(defaultContact.jobTitle),
      isDefault: new FormControl(defaultContact.isDefault),
      address: new FormControl(this.customerAddress),
      //country: new FormControl(null, Validators.required), //todo check this
      language: new FormControl(defaultContact.language),
      isMarketingRecipient: new FormControl(defaultContact.isMarketingRecipient),
      isOrderProgressRecipient: new FormControl(defaultContact.isOrderProgressRecipient),
      isShippingNotificationRecipient: new FormControl(defaultContact.isShippingNotificationRecipient),
      isInvoiceRecipient: new FormControl(defaultContact.isInvoiceRecipient),
      isCreditNoteRecipient: new FormControl(defaultContact.isCreditNoteRecipient),
      isRemarketTheBasketRecipient: new FormControl(defaultContact.isRemarketTheBasketRecipient),
    })
    this.form.markAllAsTouched(); //this will mark any empty fields as required
  }

  get canDefault(): boolean {
    const value = this.form.controls?.isDefault?.value ? this.form.controls.isDefault.value as boolean : false;
    return value && this.savedContacts.length ? this.savedContacts.filter(x => x.isDefault).length === 0 : true;
  }

  public save(form: FormGroup) {
    this.form.markAllAsTouched();
    this.formSubmitted = true;
    if (this.form.valid && this.isValidPhoneNumberProvided()) {

      this.state = State.Loading;

      const model: ISavedContactModel = this.mapping.toModelFromForm(form);

      this.savedContactsService.save(model, this.customerId)
        .subscribe((r: ISavedContactModel) => {
          console.log(r);
          this.successEmitter.emit(r);
        },
          (error) => {
            this.state = State.NewContact;
            this.fb = {
              text: `${error.status} : ${error.statusText ? error.statusText : 'An error occurred'}`,
              error: error
            };
          })

    }
  }

  public saveUpdatedContact(form: FormGroup) {
    this.form.markAllAsTouched();
    this.formSubmitted = true;
    if (this.form.valid && this.isValidPhoneNumberProvided()) {

      this.state = State.Loading;

      const model: ISavedContactModel = this.mapping.toModelFromForm(form)

      this.savedContactsService.update(model, this.customerId)
        .subscribe((r: ISavedContactModel) => {
          console.log(r);
          this.successEmitter.emit(r);
        },
          (error) => {
            this.state = State.IncompleteContact;
            this.fb = {
              text: `${error.status} : ${error.statusText ? error.statusText : 'An error occurred'}`,
              error: error
            };
          })


    }
  }

  public saveNewDefaultContact(form: FormGroup) {
    this.form.markAllAsTouched();
    if (this.form.valid) {

      this.state = State.Loading;

      const model: ISavedContactModel = this.mapping.toModelFromDefaultContact(form)

      model.isDefault = true;

      this.savedContactsService.update(model, this.customerId)
        .subscribe((r: ISavedContactModel) => {
          console.log(r);
          this.successEmitter.emit(r);
        },
          (error) => {

            //if an error occurs it's likely because the saved address is missing some details, 
            //so switch to the incomplete contact form instead
            this.fillAnIncompleteDefaultContactForm(model);
            this.fb = {
              text: `${error.status} : ${error.statusText ? error.statusText : 'An error occurred'}`,
              error: error
            };
          })


    }
  }

  numberUpdated(e: any, formControl: AbstractControl) {
    formControl.setValue(e.number);
    console.log('number updated, ' + JSON.stringify(e))
  }

  checkIsVerified(e: any, type: string) {

    console.log(e)

    if (type == 'telephoneNumber') {
      this.telephoneNumberVerified = e;
      return;
    }

    if (type == 'mobileNumber') {
      this.mobileNumberVerified = e;
      return;
    }

  }

  isPhoneNumberFormReady(formControl: AbstractControl, isFormReadyProp: boolean): boolean {

    return formControl.value || isFormReadyProp == true ? true : false

  }

  isValidPhoneNumberProvided(): boolean {
    return this.telephoneNumberVerified || this.mobileNumberVerified ? true : false
  }

}
